import { FeatureList } from "./FeatureList";

export const AboutContent = ({ data }) => {
  return (
    <div className="col-xs-12 col-md-6">
      <div className="about-text">
        <h2>About Us</h2>
        <p>{data ? data.paragraph : "loading..."}</p>
        <h3>What We Offer?</h3>
        <div className="list-style">
          <div className="col-lg-6 col-sm-6 col-xs-12">
            <FeatureList items={data?.Why} />
          </div>
          <div className="col-lg-6 col-sm-6 col-xs-12">
            <FeatureList items={data?.Why2} />
          </div>
        </div>
      </div>
    </div>
  );
};
